import {
  OutboundSOAddProductSliceType,
  setCheckItem,
  setItemQty,
} from 'features/SupplyOrder/redux/outboundSOAddProduct'
import { numberOnly, removeZeroOnFirst } from 'helpers'
import { useAppDispatch, useAppSelector } from 'store'

type RowType = {
  item: OutboundSOAddProductSliceType['data'][number]
}

const useRow = ({ item }: RowType) => {
  const dispatch = useAppDispatch()

  const qty = useAppSelector(
    (state) =>
      state.outboundSOAddProduct.selectedItems[item.productUniqueKey]?.productRequestQuantity ?? '',
  )

  const handleChangeCheckbox = () => {
    dispatch(setCheckItem(item.productUniqueKey))
  }

  const handleChangeQty = (value: string) => {
    const newValue = removeZeroOnFirst(numberOnly(value))
    dispatch(
      setItemQty({
        productUniqueKey: item.productUniqueKey,
        item: {
          productId: item.productId,
          productStock: item.productStock,
          productQrCode: item.productQrCode,
          productStatusId: item.productInventoryStatusId,
          productStatusNoteId: item.productInventoryNoteId,
          productRequestQuantity: Number(newValue),
        },
      }),
    )
  }

  return {
    qty,
    handleChangeQty,
    handleChangeCheckbox,
  }
}

export default useRow
